import PropTypes from 'prop-types';

export const Spinner = ({ className = '' }) => <div className={`spinner ${className}`} />;

Spinner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};
